import { TSubscriptionPageConfig } from '@vNext/models/PublicationConfig/SubscriptionPageConfig';
import { subscriptionShortcuts } from '../common';

export const subscriptionPageConfig: TSubscriptionPageConfig = {
    shortcuts: [
        subscriptionShortcuts.getPrivacySettings(CONFIG.privacySettings),
        subscriptionShortcuts.getSubscriptionTerms(CONFIG.subscriptionTerms),
    ],
    components: {
        delivery: {
            deviations: {
                links: {},
            },
        },
    },
};
